import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { get } from '../../../api/fetch';
import { useIsLoggedIn } from './useIsLoggedIn';
import { UserEligibility } from '../types/UserEligibility';

const eligibilityKey = 'user-eligibility';

export const useUserEligibility = (): UseQueryResult<UserEligibility> => {
  const { data: isLoggedIn } = useIsLoggedIn();

  return useQuery({
    queryKey: [eligibilityKey],
    queryFn: async () =>
      await get<UserEligibility>('/user-eligibility-api/user-eligibility-api/api/v1/user/eligibility'),
    enabled: !!isLoggedIn
  });
};
